import { render, staticRenderFns } from "./IncomeAndExpensesDetail.vue?vue&type=template&id=18ac15b4&scoped=true&"
import script from "./IncomeAndExpensesDetail.vue?vue&type=script&lang=ts&"
export * from "./IncomeAndExpensesDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac15b4",
  null
  
)

export default component.exports